import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeadset,
  faPhoneSlash,
  faPhoneAlt,
  faUser,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
const ServicesOffer = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out",
      once: true,
    });
  }, []);

  const features = [
    {
      icon: faHeadset,
      iconColor: "text-blue-600",
      title: "Bulk SMS Service",
      text: "Daily position tracking & Competitor tracking, anytime, anywhere.",
      link: "/bulk-sms",
    },
    {
      icon: faPhoneSlash,
      iconColor: "text-red-600",
      title: "Lead Management System",
      text: "Streamline your sales pipeline and capture, track, and convert leads more efficiently.",
      link: "/Leads-management-system",
    },
    {
      icon: faPhoneAlt,
      iconColor: "text-green-600",
      title: "Interactive Voice Response",
      text: "Automate calls and improve user experience seamlessly..",
      link: "/interactive-voice-response",
    },
    {
      icon: faUser,
      iconColor: "text-orange-500",
      title: "Virtual Phone Number",
      text: "Stay connected with a virtual phone number—smart, reliable, and always available for your customers.",
      link: "/virtual-phone-number",
    },
  ];

  return (
    <div className="   bg-[#F5F6F9]">
      <div className="  py-10  md:px-7 px-5">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mt-4 mb-2 text-gray-800">
          Solutions We Provide
        </h2>
        <div className=" md:w-32 w-20   h-1 bg-main1 mx-auto mb-10 rounded-full" />

        <div
          data-aos="fade-up"
          className="grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {features.map(({ icon, iconColor, title, text, link }, index) => (
            <div
              key={index}
              className="bg-white shadow-md hover:shadow    cursor-pointer transition-shadow duration-300 rounded p-6 flex flex-col justify-between h-full"
            >
              <div className="text-center">
                <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-[#ffe2ee] flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={icon}
                    className={`${iconColor} text-4xl`}
                  />
                </div>
                <h5 className="text-lg font-semibold mb-2 text-gray-800">
                  {title}
                </h5>
                <p className="text-sm text-gray-600">{text}</p>
              </div>

              <div className=" text-center mt-2">
                <Link
                  to={link}
                  className="inline-flex no-underline items-center gap-2 bg-orangeheading text-white font-semibold px-3 py-2 rounded-full shadow-md border-2 border-orangeheading transition-all duration-300 group hover:bg-transparent hover:text-orangeheading hover:shadow-lg"
                >
                  <span className="group-hover:text-orangeheading md:text-base text-sm ">
                    Learn More
                  </span>
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="transform transition-transform duration-300 group-hover:translate-x-1 group-hover:text-orangeheading"
                  />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesOffer;
